import React from 'react';

/**
 * Header band shown at the top of every page (SDD R-018).
 * @param {object} props
 * @param {string} [props.userName] Signed-in user's name. When omitted, only
 *   the product name is shown and there is no Logout button.
 * @param {() => void} [props.onLogout] Called when Logout is clicked.
 */
function BrandBand({ userName, onLogout }) {
  return (
    <header className="ui-band">
      <span>YaBuddy</span>
      {userName && (
        <div className="ui-cluster">
          <span className="ui-band__user">{userName}</span>
          <button onClick={onLogout} className="ui-button ui-button--ghost-on-band">
            Logout
          </button>
        </div>
      )}
    </header>
  );
}

export default BrandBand;
